"use client";

import MapView from "@/components/map";
import { LocationData } from "@/types/advertisements/details";

interface AddressSectionProps {
  coverageArea: string;
  relativeAddress: string;
  address?: string;
  location: LocationData;
}

export const AddressSection: React.FC<AddressSectionProps> = ({
  coverageArea,
  relativeAddress,
  location,
}) => {
  const latitude = location?.lat ?? null;
  const longitude = location?.lon ?? null;

  return (
    <div className="flex flex-col px-4 my-2 overflow-hidden">
      <div className="flex flex-col gap-2">
        {(relativeAddress || coverageArea) && (
          <div className="flex items-center text-gray-500 text-base">
            <span className="text-wrap">
              آدرس:
              {coverageArea ? ` ${coverageArea.replaceAll(",", "،")}` : ""}
              {relativeAddress ? `، ${relativeAddress}` : ""}
            </span>
          </div>
        )}
      </div>

      {latitude != null && longitude != null && (
        <div className="mt-3 overflow-hidden rounded-[15px]">
          <MapView
            latitude={latitude}
            longitude={longitude}
            height={320}
            readonly
          />
        </div>
      )}
    </div>
  );
};
